<template>
	<v-chip v-if="label && label.length > 1" size="small" variant="tonal" :color="color" readonly>{{ label }}</v-chip>
	<span v-else-if="count != null">{{ count }}</span>
	<span v-else>—</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	params: { type: Object, required: true },
});

const label = computed(() => props.params?.label || '');
const color = computed(() => props.params?.color);
const count = computed(() => props.params?.count ?? null);
</script>
